import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-ink" data-id="element-168" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-169" data-mp="3b147fjtfbx8h">
        <h2 id="testimonios" className="font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-170" data-mp="3ayqbz9uu0j0e">
          Lo que dicen <span className="text-coral" data-id="element-171" data-mp="31yl6x6d41wpe">quienes ya empezaron</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-172" data-mp="2x1l0uvg9gtya">
          Descubre cómo otros estudiantes utilizan los mapas visuales para
          organizar su aprendizaje.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-173" data-mp="v8wsk7orfgbn">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-tint bg-surface p-2.5 text-left text-ink ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-174" data-mp="qava9oz5rl18" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-175" data-mp="79v7pc5l7ki9">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={13} className="fill-gold text-gold" data-id="element-176" data-mp="zvweeo512u43" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-177" data-mp="14vsmayguj5ox">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-178" data-mp="q6cxho0vlabv">
                <p className="font-sub text-sm font-semibold text-primary" data-id="element-179" data-mp="v57kl25vll1s">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-muted" data-id="element-180" data-mp="1iuiga58dcp92">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-181" data-mp="1xgxzxcbaibnh">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
        <p className="mt-2.5 text-xs font-semibold text-white/80" data-id="element-182" data-mp="1sjfn3au5jca7">
          Acceso Inmediato • Garantía de 7 Días
        </p>
      </div>
    </section>;
}